"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _performanceNow = _interopRequireDefault(require("./vendor/performanceNow"));

var lastArg = null;
var lastResult = null;

var _default = function _default(history) {
  if (history === lastArg) {
    return lastResult;
  }

  (0, _invariant.default)(!!history.getCurrentLocation, 'Must supply a `history@3` object');

  var _history$getCurrentLo = history.getCurrentLocation(),
      initialPathname = _history$getCurrentLo.pathname;

  lastArg = history;
  lastResult = {
    pathname: initialPathname,
    listen: function listen(cb) {
      return history.listen(function (_ref) {
        var pathname = _ref.pathname;
        var timestamp = (0, _performanceNow.default)();
        cb({
          timestamp: timestamp,
          pathname: pathname
        });
      });
    }
  };
  return lastResult;
};

exports.default = _default;
module.exports = exports.default;